<template>
	<div class="global-search-input-modal-wrapper" v-if="isAllowedForShowing" @keydown.esc="closeModal()">
		<img
			:src="require(`@/drc/assets/icons/close-search.svg`)"
			alt="close"
			class="close-img"
			@click="closeModal()"
		>
		<div class="global-search-input-modal-container">
			<GlobalSearch/>
			<button class="close-modal" @click="closeModal()">{{$t('globalSearchSections.cancel')}}</button>
			<GlobalSearchResultsDropdown />
		</div>
	</div>
</template>

<script>
import GlobalSearch from "@/drc/components/globalSearch/GlobalSearch";
import GlobalSearchResultsDropdown from "@/drc/components/globalSearch/GlobalSearchResultsDropdown";
import {EventGlobalSearch} from "@/common/configurations/event-bus.js";

export default {
	name: "GlobalSearchInput",
	components: {
		GlobalSearch,
		GlobalSearchResultsDropdown
	},
	data() {
		return {
			isAllowedForShowing: false,
		}
	},
	created() {
		EventGlobalSearch.$on('show-modal', this.openModal);
	},
	beforeDestroy() {
		EventGlobalSearch.$off('show-modal');
	},
	methods: {
		closeModal() {
			this.isAllowedForShowing = false;
		},
		openModal() {
			this.isAllowedForShowing = true;
			this.setInputFieldFocus();
		},
		setInputFieldFocus() {
			window.setTimeout(function () {
				Array.from(document.getElementsByTagName("input")).forEach(el => {
					el.focus()
				})
			}, 0);
		}
	},
	watch: {
		$route(to, from) {
			this.closeModal();
		}
	}
}
</script>
